import { useRecoilState, useRecoilValue } from 'recoil';
import { useProfileAction } from '_actions';
import { profileAtom } from '_state';
import {ProfileForm, PushToggle} from '_components/profile'
export { Profile };
function Profile() {
    const [profile,setProfile] = useRecoilState(profileAtom);
    return (
        <div className="profile-page">
            <div className="profile-crumb">Tài khoản / Hồ sơ cá nhân</div>
            <h1 className="profile-title">Hồ sơ cá nhân</h1>
            <div className="profile-sub">Xem và cập nhật thông tin cá nhân của bạn</div>
            <PushToggle />
            <ProfileForm data = {profile} isTable = {false}/>
        </div>
    );
}